import { service } from "@ember/service";
import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import destroyRecord from "glesys-controlpanel/utils/destroy-record";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class ApiAccessController extends Controller {
  @service ajax;
  @service session;
  @service store;

  get projects() {
    return this.model.projects;
  }

  get organizations() {
    return this.model.organizations;
  }

  get apiKeysCount() {
    let count = 0;
    this.projects.forEach((project) => (count += project.get("apiKeysCount")));
    return count;
  }

  createKeyTask = task(async (project, description) => {
    let key = this.store.createRecord("api-key", {
      project,
      description,
    });

    await this.store.request(saveRecord(key)).catch((e) => {
      destroyRecord(key);
      throw e;
    });

    // make nonsical update to key to refresh the model with permissions.
    await this.updateApiKeyTask.perform(key, "id", key.id);
  });

  updateApiKeyTask = task(async (apiKey, property, value) => {
    try {
      await apiKey.set(property, value);
      await this.store.request(saveRecord(apiKey));
    } catch (error) {
      apiKey.rollbackAttributes();
      throw error;
    }
  });

  deleteApiKeyTask = task(async (apiKey) => {
    await destroyRecord(apiKey);
  });
}
